import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IonInfiniteScroll, ModalController} from '@ionic/angular';
import { GlobalService } from './../../../../config/services/global.service';

@Component({
    selector: 'app-modal-concepto',
    templateUrl: './modal-concepto.component.html',
    styleUrls: ['./modal-concepto.component.scss'],
})
export class ModalConceptoComponent implements OnInit {
    @ViewChild('conceptoSearchBar')conceptoSearchBar;
    
    @Input() select: string;
    @Input() tipo: string;

    public conceptoList:any;
	  public loadConcepto:    boolean = true;
    public loadConceptoIni: boolean = false;
    public showSearch:    boolean = false;
    public from: any;
    public itemSelect = [];

  	constructor( 
  		private globalService: GlobalService,
  		private router: Router,
  		public  modalController: ModalController
  	) {
  		this.conceptoList = {list: [], page: 0, pages: 0, iTotal: 0, search: ''}
  	}

  	ngOnInit() {
  		if(this.globalService.selects.conceptos.length <= 0){
        	this.list('ini', null, 'Cargando...');
  		}else{
  			this.conceptoList.list = this.globalService.selects.conceptos;
  		}
        this.focusSearch();
  	}
    
    focusSearch() {
        setTimeout(() =>{
        	this.conceptoSearchBar.setFocus();
        },400);
    }

  	async list(from, ev, loadinSMS) {
  		const token       = await this.globalService.getToken();
        const entidad:any = await this.globalService.entidadDefault();

        this.conceptoList.page       = this.conceptoList.page+1;
        let params                 = {};
            params['take']         = 1000;
            params['page']         = this.conceptoList.page;
            params['search']       = this.conceptoList.search;
            params['appID']        = this.globalService.appID;
            params['sedeID']       = entidad.sedeID;
            params['conceptoID']   = null;
        this.loadConcepto = true;
        this.globalService.requestPost('admin/concepto', params, 'jwt', token).subscribe(
            data => {
                if(data.validation == 'ok'){
                    let disabled = true;
                    if(data.list.length > 0){ 
                    	this.globalService.selects.conceptos = data.list;
                        this.conceptoList.list = data.list;
                        disabled = false;
                    }
                    this.loadConcepto    = false;
                    this.loadConceptoIni = true;
                    if(this.showSearch){
                    	this.focusSearch();
                    }
                }else{
                    this.globalService.failRequestHttp(data);
                }
            },
            error => {
                this.globalService.errorRequestHttp(error)
            }
        );
  	}

  	async conceptoSelect(item, ev) {
        if(this.select == 'single') {
            this.modalController.dismiss({
                'conceptoInfo': item
            });
        }else if(this.select == 'singleMultiple') {
            this.itemSelect.push(item);
            this.modalController.dismiss({
                'conceptoInfo': item
            });
        }
    }

  	async dismissModal(ev) {
        this.modalController.dismiss({
            'conceptoInfo': null
        })
    }
}




